$(document).ready(function() {


  let all_product_variants = document.querySelectorAll('.variant-input');
  function variant_pointer_events(pointer_style){
    
    all_product_variants.forEach((btn)=> {
      btn.style.pointerEvents = pointer_style;
    })
    
  }
  
  if ($(".variant-input.w-o-personalization input").prop("checked")) {
      variant_pointer_events("none");
      let maxTries = 30
      let timesTried = 0
      const findApp = setInterval(function () {
        if ($('#zakeke-product-button').length) {
          console.log('zakeke button Find')
          variant_pointer_events("auto");
          clearInterval(findApp)
          $("button#zakeke-product-button").addClass("disable-btn")
        } if (timesTried > maxTries) {
          console.log('zakeke button')
          clearInterval(findApp)
        }
        console.log('Zakeke Trying')
        timesTried++
      }, 300);
  }
  // Product Page Disable Buttons Issue

  if ($(".variant-input.variant-input.personalized-lid input, .variant-input.variant-input.personalized input").prop("checked")) {
      variant_pointer_events("none");
      let maxTries = 30
      let timesTried = 0
      const findApp = setInterval(function () {
        if ($('#zakeke-product-button').length) {
          console.log('zakeke button Find')
          variant_pointer_events("auto");
          clearInterval(findApp)
          $("button.btn.btn--full.add-to-cart[type='submit']").addClass("disable-btn")
        } if (timesTried > maxTries) {
          console.log('zakeke button')
          clearInterval(findApp)
        }
        console.log('Zakeke Trying')
        timesTried++
      }, 300);
  }
});
$(document).on("change",".variant-input input",function(){
    if ($(".variant-input.w-o-personalization input").prop("checked")) {
        $("button#zakeke-product-button").addClass("disable-btn") && $("button.btn.btn--full.add-to-cart[type='submit']").removeClass("disable-btn");
    }
    if ($(".variant-input.variant-input.personalized-lid input, .variant-input.variant-input.personalized input").prop("checked")) {
        $("button.btn.btn--full.add-to-cart[type='submit']").addClass("disable-btn") && $("button#zakeke-product-button").removeClass("disable-btn");
    }
});
